import React from 'react';

const LazyMostPopularPicks = React.lazy(() =>
  import(/* webpackChunkName: "MostPopularPicks" */ './mostPopularPicks')
);

const MostPopularPicks = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyMostPopularPicks {...props} />
  </React.Suspense>
);

export default MostPopularPicks